<script setup>
import SearchBox from "./SearchBox.vue";
import QuestionPanel from "./QuestionPanel.vue";
import SearchResultPanel from "./SearchResultPanel.vue";
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
const store = useStore();
const keyword = computed(() => store.getters.getKeyword);
const isInputting = computed(() => store.getters.isInputting);
</script>

<template>
  <SearchBox/>
  <SearchResultPanel v-if="isInputting"/>
  <QuestionPanel v-else/>
</template>

<style scoped lang="scss">

</style>
